module.exports = __webpack_public_path__ + "static/media/lexus-checkmark.5139c38a.svg";